import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNewVersionAvailable } from '@/lib/version';

/** A bar under the top bar once a new version of Taim is deployed, offering to reload. */
export function UpdateNotice() {
  const available = useNewVersionAvailable();
  if (!available) return null;
  return (
    <div
      role="status"
      className="flex shrink-0 items-center justify-center gap-3 border-b bg-secondary px-4 py-1.5 text-secondary-foreground text-sm"
    >
      <span>A new version of Taim is available.</span>
      <Button size="sm" onClick={() => window.location.reload()}>
        <RefreshCw /> Refresh
      </Button>
    </div>
  );
}
